import type { IconProps } from './types';

const TableSortIcon = (props: IconProps) => {
  const { width = 24, height = 24, viewBox = '0 0 24 24' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <mask id="mask0_7938_17939" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7938_17939)">
        <path
          d="M4.25 17.5C4.0375 17.5 3.85938 17.428 3.71563 17.2842C3.57188 17.1404 3.5 16.9622 3.5 16.7496C3.5 16.537 3.57188 16.3589 3.71563 16.2154C3.85938 16.0718 4.0375 16 4.25 16H8.12498C8.33748 16 8.5156 16.0719 8.65935 16.2157C8.8031 16.3595 8.87498 16.5377 8.87498 16.7503C8.87498 16.9629 8.8031 17.141 8.65935 17.2846C8.5156 17.4282 8.33748 17.5 8.12498 17.5H4.25ZM4.25 12.75C4.0375 12.75 3.85938 12.6781 3.71563 12.5343C3.57188 12.3904 3.5 12.2122 3.5 11.9997C3.5 11.7871 3.57188 11.609 3.71563 11.4654C3.85938 11.3218 4.0375 11.25 4.25 11.25H13.9327C14.1452 11.25 14.3233 11.3219 14.467 11.4657C14.6108 11.6095 14.6827 11.7877 14.6827 12.0003C14.6827 12.2129 14.6108 12.391 14.467 12.5346C14.3233 12.6782 14.1452 12.75 13.9327 12.75H4.25ZM4.25 7.99998C4.0375 7.99998 3.85938 7.92807 3.71563 7.78425C3.57188 7.64045 3.5 7.46225 3.5 7.24965C3.5 7.03707 3.57188 6.85898 3.71563 6.7154C3.85938 6.5718 4.0375 6.5 4.25 6.5H19.75C19.9625 6.5 20.1406 6.57191 20.2843 6.71573C20.4281 6.85954 20.5 7.03774 20.5 7.25033C20.5 7.46293 20.4281 7.64102 20.2843 7.7846C20.1406 7.92818 19.9625 7.99998 19.75 7.99998H4.25Z"
          fill="#124E78"
        />
      </g>
    </svg>
  );
};

export default TableSortIcon;
